module.exports = __webpack_public_path__ + "static/jeff-atwood-9b5c4b1dffa70f46326d41a30a6998c4.jpg";